<template>
    <div>
        <modal-upload v-show="showModalUpload" v-bind:content="{fileData:fileData}"></modal-upload>
        <div class="col-md-12">


            <div class="card abtg__default-card abtg__default-card-border">
                <div class="card-head">
                    <header >{{$t('info.title_auction')}}</header>
                    <div class="abtg__header_popover">
                        <popover module="auction" content="resource" color="grey" position="right"></popover>
                    </div>
                    <div class="tools">
                        <a @click="triggerModalUpload()"  class="btn btn-default      shadow-none abtg__btn-tool">  {{$t('operation.modal_risorsa')}}</a>

                    </div>
                </div>
                <div class="card-body ">

                    <div class="row">
                        <div class="col">

                            <carousel v-bind:content="{images: imagesList, countImg: Number(countImages)}"
                                      v-if="Number(countImages) > 0"></carousel>

                        </div>
                    </div>


                    <div class="row" v-if="Number(countImages) > 0">
                        <div class="col">
                            <hr>
                            <h4>Immagini e documenti</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <ul class="abtg__ul-resources">
                                <li v-for="file in imagesList">
                                    <div class="row">
                                        <div class="col">
                                            <a :href="'/storage/' + file.nome_file" target="_blank"><i
                                                    class="far fa-image"></i> {{file.descrizione}}</a>
                                        </div>
                                        <div class="col text-right"><a @click="modifyFile(file.id)"><i
                                                class="fas fa-pencil-alt"></i></a></div>
                                    </div>

                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <ul class="abtg__ul-resources">
                                <li v-for="file in fileList">
                                    <div class="row">
                                        <div class="col">
                                            <a :href="'/storage/' + file.nome_file" target="_blank"><i
                                                    class="far fa-file-pdf"></i> {{file.descrizione}}</a>
                                        </div>
                                        <div class="col text-right"><a @click="modifyFile(file.id)"><i
                                                class="fas fa-pencil-alt"></i></a></div>
                                    </div>

                                </li>
                            </ul>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'
    import {Money} from 'v-money';
    import modalUpload from '../commons/modal_upload_file';
    import {createHelpers} from 'vuex-map-fields';
    import carousel from '../commons/carousel';
    import Popover from '../commons/popover';


    const {mapFields} = createHelpers({
        getterType: 'auction/getField',
        mutationType: 'auction/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Money, modalUpload, carousel, Popover},
        props: ['page'],
        data: function () {
            return {
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                }
            }
        },

        computed: {
            ...mapFields(['showModalUpload', 'myFileUpload', 'myDescriptionUpload', 'myFileIdUpload', 'operationId', 'fileList', 'fileId', 'fileData', 'imagesList', 'countImages']),
        },
        created: function () {
            this.fileList();
        },

        methods: {
            triggerModalUpload: function () {
                this.$store.dispatch('upload/clearFormData', null, {root: true});
                this.$store.dispatch('auction/triggerModalUpload');
            },

            /**
             * For modal upload file
             *
             */
            modifyFile: function (id) {
                this.fileId = id; // useful for deleteFile method
                this.$store.dispatch('auction/retrieveFile', id);
            },

            /**
             * from modal upload file
             */
            onSubmitFile: function (file, description, id) {
                this.myFileUpload = file;
                this.myDescriptionUpload = description;
                this.myFileIdUpload = id;
                this.$store.dispatch('auction/sendUploadFile', {auctionId: this.page});
            },

            fileList: function () {

                this.$store.dispatch('auction/fileList', {auctionId: this.page});
            },

            deleteFile: function () {
                this.$store.dispatch('auction/removeFile', this.fileId);
                this.$store.dispatch('auction/triggerModalUpload');
            },

        }
    }
</script>